import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import ReactQuill from "react-quill";
import {Fieldset} from "primereact/fieldset";
import {Card} from 'primereact/card';
import {Panel} from 'primereact/panel';
import {InputText} from "primereact/inputtext";
import axios from "axios";
import {Dropdown} from "primereact/dropdown";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";


function MyEditor() {
}

MyEditor.modules = {
    toolbar: [

        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        ['bold', 'italic', 'underline', 'strike'],                                                      // toggled buttons
        ['blockquote', 'code-block'],

        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}, {'align': []}],
        [{'script': 'sub'}, {'script': 'super'}],                                                       // superscript/subscript
        [{'direction': 'rtl'}],                                                                         // text direction,
        [{'font': []}],
        [{'align': []}],
        [{'color': []}, {'background': []}],                                                            // dropdown with defaults from theme

        ['link'],

        ['clean']                                                                                       // remove formatting button
    ],

}

MyEditor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "code-block",

];


const SSSAdd = props => {
    const toast = useRef(null);
    const [moduleList, setModuleList] = useState([]);
    const [submoduleList, setSubmoduleList] = useState([]);
    const [competitionList, setCompetitionList] = useState([]);
    const [modulID, setModulID] = useState('');
    const [smodulID, setSmodulID] = useState('');
    const [compID, setCompID] = useState('');
    const [smdCode, setSmdCode] = useState('');
    const [faqQuestion, setFaqQuestion] = useState('');
    const [faqAnswer, setFaqAnswer] = useState('');
    const [faqID, setFaqID] = useState('');
    const sss_add_role = localStorage.getItem('sss_add') ? true : false;


    useEffect(() => {

            getModuleList();
            getSSSList();
            getSubModuleList();
            getCompetition();
        }
        ,
        []
    )
    ;

    const getSSSList = () => {
        const faq_id = parseInt(props.match.params['faq_id']);
        if (Number.isInteger(faq_id)) {
            setFaqID(faq_id)
            const token = localStorage.getItem("token");
            const headers = {"Authorization": "Token " + token}
            axios.get('/api/sss' + `/${faq_id}/`, {"headers": headers})
                .then(res => {
                    const data = res.data.result_sss_data
                    //console.log(data, "dataaa")
                    for (let i = 0; i < data.length; i++) {
                        const file = data[i];
                        setFaqQuestion(file.faq_question)
                        setFaqAnswer(file.faq_answer)
                        setModulID(file.md_id)
                    }
                })
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 401) {
                        props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })

        }
    }
    const handleBody = e => {
        setFaqAnswer(e);
    };
    const getModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/content/module/list/', {"headers": headers})
            .then(res => {

                setModuleList(res.data)
            })
    }
    const getSubModuleList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/md-submodule/', {"headers": headers})
            .then(res => {

                setSubmoduleList(res.data.sub_module_list)
                setSmdCode(res.data.sub_module_list[0].smd_code)
                //console.log(res.data.sub_module_list[0].smd_code, "kenan")
            })
    }
    const getCompetition = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/competition/', {"headers": headers})
            .then(res => {

                setCompetitionList(res.data.competition_list)
            })
    }
    const CompetitionOptionItems = competitionList.map((item) => (
        {"label": item.comp_name, "value": item.comp_id}
    ))
    const ModuleOptionItems = moduleList.map((item) => (
        {"label": item.md_name, "value": item.md_id}
    ))


    const showSuccess = (message) => {
        toast.current.show({severity: 'success', life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const submit = () => {
        const obj = {
            modulID: modulID,
            faqQuestion: faqQuestion,
            faqAnswer: faqAnswer,
            smodulID: smodulID,
            compID: compID

        };
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            if (faqID) {
                fetch("/api/sss" + "/" + faqID + "/", {headers, method: "PUT", body})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            const data = res.data;

                            if (data.result) {
                                window.location.hash = '/sss'

                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })
            } else {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                fetch("/api/sss/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {

                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {

                            const data = res.data;
                            if (data.result) {
                                window.location.hash = '/sss'

                                showSuccess(data.message);
                                // setData(data.result)
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            throw res.data;

                        } else if (res.status === 403) {
                            throw res.data;

                        }
                    })
            }
        }

        setFaqAnswer('')
        setFaqQuestion('')
        setModulID('')


    }
    if (sss_add_role) {
        return (
            <div className="p-fluid" style={{fontSize: 'large'}}>
                <Toast ref={toast}/>

                <Panel>
                    <Card className="p-card-content">
                        <form onSubmit={submit}>

                            <div className="p-grid">
                                <div className="p-col-10 p-md-offset-1" align="center">

                                    <div className="p-col-12 p-md-12">

                                        <Fieldset legend="Modül Seçimi" toggleable>
                                            <div className="p-col-12 p-md-12">

                                                <Dropdown
                                                    options={ModuleOptionItems}
                                                    onChange={(e) => setModulID(e.target.value)}
                                                    value={modulID}
                                                    showClear={true}
                                                    required={true}
                                                    placeholder="Modül Seçiniz"

                                                />
                                            </div>
                                            {/*<div className="p-col-12 p-md-12">*/}

                                            {/*    <Dropdown*/}
                                            {/*        options={SubmoduleOptionItems}*/}
                                            {/*        onChange={(e) => setSmodulID(e.target.value)}*/}
                                            {/*        value={smodulID}*/}
                                            {/*        showClear={true}*/}
                                            {/*        placeholder="Alt Modül Seçiniz"*/}
                                            {/*        style={{*/}
                                            {/*            visibility: modulID === 3 ? 'visible' : 'hidden'*/}
                                            {/*        }}*/}

                                            {/*    />*/}
                                            {/*</div>*/}
                                            <div className="p-col-12 p-md-12">

                                                <Dropdown
                                                    options={CompetitionOptionItems}
                                                    onChange={(e) => setCompID(e.target.value)}
                                                    value={compID}
                                                    showClear={true}
                                                    placeholder="Yarışma Seçiniz"
                                                    style={{
                                                        visibility: modulID === 3 ? 'visible' : 'hidden'
                                                    }}


                                                />
                                            </div>
                                        </Fieldset>
                                        <div className="p-mt-2">
                                            <Fieldset legend="Soru-Cevap" toggleable>

                                                <div className="p-col-12 p-md-12">
                                                    <InputText
                                                        value={faqQuestion}
                                                        onChange={(e) => setFaqQuestion(e.target.value)}
                                                        name="text"
                                                        id="text"
                                                        minLength={2}
                                                        maxLength={100}
                                                        required
                                                        placeholder="Soru Ekle"


                                                        className="p-inputtext-lg p-d-block"
                                                    />
                                                </div>
                                                <div className="p-col-12 p-md-12" align="left">

                                                    <ReactQuill
                                                        style={{
                                                            maxHeight: '600px',
                                                            overflowY: 'scroll',
                                                            overflowX: 'block'
                                                        }}
                                                        placeholder="Cevap Ekle"
                                                        modules={MyEditor.modules}
                                                        formats={MyEditor.formats}
                                                        onChange={handleBody}
                                                        value={faqAnswer}

                                                    >

                                                    </ReactQuill>

                                                </div>

                                            </Fieldset>
                                        </div>

                                    </div>

                                </div>


                            </div>


                            <div className="p-col-12 p-md-12" align="center">

                                <div className="p-mt-2">

                                    <Button label="Ekle" icon="pi pi-check" className="p-button-secondary"
                                            onClick={submit}
                                            style={{height: '40px', width: '15%'}}/>
                                </div>
                            </div>
                        </form>
                    </Card>

                </Panel>
            </div>
        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SSSAdd);


// WEBPACK FOOTER //
// ./src/pages/modulemanagement/SSSAdd.jsx